import { Branch, CreateBranchRequest, PaginatedResponse, UpdateBranchRequest } from '../types';
import apiService from './api';

export class BranchService {
  async getAllBranches(
    page: number = 0,
    size: number = 10,
    sort?: string,
    filters?: any
  ): Promise<PaginatedResponse<Branch>> {
    return apiService.getPaginated<Branch>('/api/branches/admin/all', page, size, sort, filters);
  }

  async getBranchById(id: string): Promise<Branch> {
    return apiService.get<Branch>(`/api/branches/admin/${id}`);
  }

  async createBranch(branchData: CreateBranchRequest): Promise<Branch> {
    return apiService.post<Branch>('/api/branches', branchData);
  }

  async updateBranch(id: string, branchData: UpdateBranchRequest): Promise<Branch> {
    return apiService.put<Branch>(`/api/branches/${id}`, branchData);
  }

  async deleteBranch(id: string): Promise<void> {
    await apiService.delete(`/api/branches/${id}`);
  }

  async getNearbyBranches(
    latitude: number,
    longitude: number,
    radius: number = 10
  ): Promise<Branch[]> {
    return apiService.get<Branch[]>('/api/branches/nearby', {
      latitude,
      longitude,
      radius,
    });
  }
}

export const branchService = new BranchService();
export default branchService;
